module.exports = __webpack_public_path__ + "img/chevron-up-new.e66867f0.svg";